export default __webpack_public_path__ + "static/media/Trade_Gothic_LT_Light.6c734739.woff";